import useAppCustom from '@hooks/useAppCustom';
import CouponIcon from '@icons/CouponIcon';
import EventIcon from '@icons/EventIcon';
import HomeLineIcon from '@icons/HomeLineIcon';
import MapIcon from '@icons/MapIcon';
import OrderIcon from '@icons/OrderIcon';
import PointIcon from '@icons/PointIcon';
import PrepaidCardIcon from '@icons/PrepaidCardIcon';
import StampIcon from '@icons/StampIcon';
import { NavigationItem } from '@models/custom';

import NavItem from './NavItem';
import styles from './styles.module.scss';

function NavigationBar() {
  const { navigationItems } = useAppCustom().main;
  return (
        <nav className={styles.container} >
            <NavItem label='메인'
                     isCurrent
                     activityParams={{}}
                     icon={HomeLineIcon}/>
            {navigationItems?.map((item, index) => makeMenu(item, index === 1))}
        </nav>
  );
}

function makeMenu(navigationItem: NavigationItem, isCenter: boolean) {
  switch (navigationItem) {
    case 'PREPAID_CARD':
      return <NavItem label='선불카드'
                      useGuard
                      isCenter={isCenter}
                      activityName='MyPrepaidCardActivity'
                      activityParams={{}}
                      icon={PrepaidCardIcon}/>;
    case 'SHOP':
      return <NavItem label='매장찾기'
                      isCenter={isCenter}
                      key={navigationItem}
                            activityName='ShopListActivity'
                            activityParams={{ isOrder: false, type: 'LIST' }}
                            icon={MapIcon}/>;
    case 'EVENT':
      return <NavItem label='이벤트'
                      isCenter={isCenter}
                      key={navigationItem}
                            activityName='BoardActivity'
                            activityParams={{ type: 'EVENT' }}
                            icon={EventIcon}/>;
    case 'COUPON':
      return <NavItem label='쿠폰'
                      useGuard
                      isCenter={isCenter}
                      activityName='CouponActivity'
                      activityParams={{ type: 'MY' }}
                      icon={CouponIcon}/>;
    case 'POINT':
      return <NavItem label='포인트'
                      useGuard
                      isCenter={isCenter}
                      activityName='PointActivity'
                      activityParams={{}}
                      icon={PointIcon}/>;
    case 'STAMP':
      return <NavItem label='스탬프'
                      useGuard
                      isCenter={isCenter}
                      activityName='StampsActivity'
                      activityParams={{}}
                      icon={StampIcon}/>;
    case 'GIFT':
      return <NavItem label='선물하기'
                      useGuard
                      isCenter={isCenter}
                      activityName='GiftsActivity'
                      activityParams={{ type: 'MAIN' }}
                      icon={StampIcon}/>;
    case 'ORDER':
      return (
              <NavItem label='주문'
                       isCenter={isCenter}
                       activityName='ShopListActivity'
                       activityParams={{ isOrder: true, type: 'LIST' }}
                       icon={OrderIcon}/>
      );
    default:
      throw new Error('Unknown navigation item');
  }
}

export default NavigationBar;
